export const experienceData = [
  {
    id: 1,
    company: "Spark Studio",
    jobtitle: "Core Frontend Developer",
    startYear: "Oct 2021",
    endYear: "Present",
  },
  {
    id: 2,
    company: "Solvio.ai",
    jobtitle: "Frontend developer",
    startYear: "Jun 2020",
    endYear: "Sept 2021",
  },
  {
    id: 3,
    company: "Learning New Technology For Everyday",
    jobtitle: "Self Learning",
    startYear: "2019",
    endYear: "Present",
  },
];
